import configConversionUtils from './configconversion';
import {get, post} from './utils';

const configDao = {
  queryConfig: async () =>
    configConversionUtils.fromDB(
      await get('/smb-backend/webmodule/query-module-settings.action')
    ),
  queryCredential: async () =>
    configConversionUtils.credential.fromDB(
      await get('/smb-backend/webmodule/query-credential.action')
    ),
  updateConfig: settings =>
    post('/smb-backend/webmodule/update-module-settings.action', {
      config: configConversionUtils.toDB(settings),
    }),
};

export default configDao;
